export default __webpack_public_path__ + "agent_bg4_m6cebe9.png";